import content from "@/content/hero.json";
import { Secundary_Btn } from "@/components/ui/WhatsApp";
import WhatsApp from "@/components/ui/WhatsApp";

import { Clock, TrendingUp, Smartphone } from "lucide-react";

interface Data {
  callToAction: string;
  title: string;
  description: string;
  details: string;
}

const data: Data = content;

const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-32 pb-20 lg:pt-48 lg:pb-32">
      <div className="bg-grid absolute inset-0 opacity-30" />
      <div className="from-background to-background absolute inset-0 bg-linear-to-b via-transparent" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <div className="border-border bg-secondary/50 mb-6 inline-flex items-center gap-2 rounded-full border px-4 py-1.5 backdrop-blur-sm">
            <span className="relative flex h-2 w-2">
              <span className="bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75" />
              <span className="bg-primary relative inline-flex h-2 w-2 rounded-full" />
            </span>
            <span className="text-muted-foreground text-sm font-medium">
              {data.callToAction}
            </span>
          </div>

          <h1 className="font-display text-foreground text-5xl leading-[0.95] tracking-wide sm:text-6xl md:text-7xl lg:text-8xl">
            {data.title
              .trim()
              .split(/\s+/)
              .map((word, index) =>
                index === 2 ? (
                  <span key={index} className="text-gradient">
                    {word}{" "}
                  </span>
                ) : (
                  `${word} `
                ),
              )}
          </h1>

          <p className="text-muted-foreground mx-auto mt-6 max-w-2xl text-lg leading-relaxed sm:text-xl">
            {data.description}
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <WhatsApp className="group bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-primary/25 inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-semibold transition-all hover:shadow-xl" />
            <Secundary_Btn className="border-border bg-secondary text-foreground hover:bg-secondary/80 inline-flex items-center gap-2 rounded-full border px-8 py-4 text-base font-semibold transition-colors" />
          </div>

          <div className="text-muted-foreground mt-12 flex flex-wrap items-center justify-center gap-8 text-sm">
            <div className="flex items-center gap-2">
              <Clock className="text-primary h-4 w-4" />
              <span>Entrega rápida</span>
            </div>
            <div className="flex items-center gap-2">
              <TrendingUp className="text-primary h-4 w-4" />
              <span>Foco em retenção</span>
            </div>
            <div className="flex items-center gap-2">
              <Smartphone className="text-primary h-4 w-4" />
              <span>Atendimento via WhatsApp</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
